import { ReactNode } from 'react';
import { HelmetContext, HelmetProvider } from 'react-helmet-async';

export interface MetadataContext extends HelmetContext {}

interface MetadataProviderProps {
  children: ReactNode;
  context: MetadataContext;
}

export const MetadataProvider = ({ children, context }: MetadataProviderProps) => {
  return <HelmetProvider context={context}>{children}</HelmetProvider>;
};
